__turbopack_context__.v({
  "item": "side-nav-menu-item-module__906n9W__item",
  "link": "side-nav-menu-item-module__906n9W__link",
});
